import React from "react";

const Maintenance = () => <h1>設計製造・AI・IoT・DX バーチャルオンライン展示会 2022 秋の会期は終了しました。</h1>;

export default Maintenance;
